import { render } from "./learnButton.vue?vue&type=template&id=49536a6b"
import script from "./learnButton.vue?vue&type=script&lang=js"
export * from "./learnButton.vue?vue&type=script&lang=js"

import "./learnButton.vue?vue&type=style&index=0&id=49536a6b&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__